// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tool-landing-hero{height:45rem}@media (max-width:768px){.tool-landing-hero{height:auto;min-height:45rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
